import React, {Component} from 'react';
import './Group.css';
import {Link} from "react-router-dom";

class GroupFilter extends Component {

    render() {

        if (this.props.configuration.group == "Format") {
            let className = "MaintenantV2-Group-Filter Filter-";
            let text = this.props.data.key

            switch (this.props.data.key) {
                case "Film":
                    className += "film";
                    break;
                case "En débat":
                case "Débat":
                    className += "debat";
                    text = "Débat";
                    break;
                case "Atelier":
                    className += "atelier";
                    break;
                case "Moments musicaux":
                case "Musique":
                    className += "musique";
                    text = "Musique";
                    break;
                case "Spectacles":
                case "Spectacle":
                    text = "Spectacle"
                    className += "spectacle";
                    break;
                case "En action":
                    className += "action";
                    break;
                case "Présentation":
                    className += "presentation";
                    break;
                case "Conférence":
                    className += "conference";
                    break;
                case "Evénement":
                    className += "events";
                    break;
            }

            if (this.props.active) {
                className += " active";
            }

            return (
                <div className={className}>
                    {text}
                </div>
            );

            return null;

        } else {
            let day = "";
            let br = "";
            switch (this.props.data.key) {
                case "13/9":
                    day = "Vendredi";
                    break;
                case "25/9":
                    day = "Mercredi";
                    break;
                case "26/9":
                    day = "Jeudi";
                    break;
                case "27/9":
                    day = "Vendredi";
                    break;
                case "28/9":
                    day = "Samedi";
                    break;
                case "29/9":
                    day = "Dimanche";
                    break;
            }

            if (day) {
                br = <br/>;
            }

            let className = "MaintenantV2-Group-Filter";
            if (this.props.active) {
                className += " active";
            }

            return (
                <div className={className}>
                    {day}{br}
                    {this.props.data.key}
                </div>
            );
        }
    }
}

export default GroupFilter;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2/GroupFilter.js